import FormField from '../models/serviceModels/FormField';
import { getEthnicityFieldVisible, isDemographicVisible } from './demographicsSchema';

const isSubmissionFieldVisible = (fieldName: string, organization: any) => {
    if (fieldName === 'main_profile_preferred_pronouns') {
        return isDemographicVisible(organization, 'pronouns');
    }

    if (fieldName === 'main_profile_gender' || fieldName === 'gender') {
        return isDemographicVisible(organization, 'gender');
    }

    if (fieldName === 'main_profile_ethnicity' || fieldName === 'ethnicity') {
        return getEthnicityFieldVisible(organization);
    }

    if (fieldName === 'main_profile_race' || fieldName === 'race') {
        return isDemographicVisible(organization, 'race');
    }

    return true;
};

const getVisibleSubmissionFormFields = (fields: FormField[], organization: any): FormField[] => fields
    .filter(field => isSubmissionFieldVisible(field.name, organization))
    .map(field => {
        if (field.name !== 'main_profile_family_members' || !field.schema) {
            return field;
        }

        try {
            const parsedSchema: any[] = JSON.parse(field.schema);
            return {
                ...field,
                schema: JSON.stringify(
                    parsedSchema.filter(schemaField => isSubmissionFieldVisible(schemaField.fieldName, organization))
                )
            };
        } catch (error) {
            console.warn('Failed to parse public submission household schema', error);
            return field;
        }
    });

export { getVisibleSubmissionFormFields, isSubmissionFieldVisible };
